var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPlugin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5333_10455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88012 3.32537L5.27056 1.93443L5.28106 8.75014C5.28106 9.16433 5.61683 9.50011 6.03103 9.50011C6.44522 9.50011 6.78099 9.16433 6.78099 8.75014L6.77049 1.94294L8.15294 3.32539C8.44069 3.62331 8.91547 3.63156 9.2134 3.34381C9.51132 3.05606 9.51957 2.58128 9.23182 2.28336C9.22577 2.2771 9.21963 2.27096 9.2134 2.26493L7.60746 0.658996C6.72882 -0.219661 5.30426 -0.219661 4.4256 0.658973L2.81966 2.26491C2.53191 2.56284 2.54016 3.03761 2.83808 3.32537C3.12872 3.60606 3.58948 3.60606 3.88012 3.32537Z",
    fill: "#F9F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2498 7.25C10.8356 7.25 10.4998 7.58577 10.4998 7.99997V10.2954C10.4995 10.4082 10.4081 10.4996 10.2953 10.4998H1.70466C1.59184 10.4996 1.50044 10.4082 1.50018 10.2954V7.99997C1.50018 7.58577 1.1644 7.25 0.750212 7.25C0.336019 7.25 0.000244141 7.58577 0.000244141 7.99997V10.2954C0.00134566 11.2362 0.763805 11.9987 1.70466 11.9998H10.2953C11.2362 11.9987 11.9986 11.2362 11.9997 10.2954V7.99997C11.9997 7.58577 11.664 7.25 11.2498 7.25Z",
    fill: "#F9F9FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5333_10455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPlugin);
export default __webpack_public_path__ + "static/media/upload-plugin.086a297e476f75a95fac59f48de5c2f4.svg";
export { ForwardRef as ReactComponent };